import { ofType } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  priceImprovementTraderAcknowledged,
  priceImprovementTraderRejected,
  priceImprovementTraderValidated,
} from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.actions';
import type { EpicWithThunk } from 'state/state.common';

export function priceImprovementMessageReceivedEpic(): EpicWithThunk {
  return (action$, state$, { streaming }) =>
    action$.pipe(
      ofType('PRICE_IMPROVEMENT_CREATE_RECEIVED'),
      withLatestFrom(state$),
      mergeMap(([{ requestForPriceImprovementId }]) => {
        return streaming.priceImprovementMessage$.pipe(
          ofType('PriceImprovementAcknowledged', 'PriceImprovementRejected', 'PriceImprovementValidated'),
          filter(event => event.rfpiId === requestForPriceImprovementId),
          map(event => {
            switch (event.type) {
              case 'PriceImprovementAcknowledged':
                return priceImprovementTraderAcknowledged(event.rfpiId, event.quoteId);
              case 'PriceImprovementRejected':
                return priceImprovementTraderRejected(event.rfpiId, event.quoteId, event.comment);
              case 'PriceImprovementValidated':
                return priceImprovementTraderValidated(
                  event.rfpiId,
                  event.quoteId,
                  Number(event.priceAdjustment),
                  event.comment,
                );
            }
          }),
        );
      }),
    );
}
